import { GET_CUSTOMER_ACTIVITY_HISTORY } from 'activity-history-lib';
function getEmptyActivityHistory() {
  return {
    activities: [],
    hasMore: false,
    offset: 0,
    totalCount: 0
  };
}

// This function can be called in a card registry in order to fire a request
// before your JS has loaded and evaluated.
export const dataResolver = ({
  graphqlClient: __graphqlClient,
  dfcClient
}, {
  cardData: __cardData,
  additionalLocationData: {
    objectId,
    objectTypeId
  }
}) => {
  const objectType = objectTypeId === '0-3' ? 'DEAL' : 'COMPANY';
  if (!objectId) {
    return Promise.resolve(getEmptyActivityHistory());
  }
  return dfcClient.query({
    query: GET_CUSTOMER_ACTIVITY_HISTORY,
    variables: {
      objectType,
      objectId,
      limit: 5,
      offset: 0
    }
  }).then(result => result.data.customerActivityHistory);
};